<template>
  <custom-card>
    <template v-slot:title>{{ $t('emotes.title') }}</template>
    <template v-slot:content>
      <v-row style="margin-bottom: 200px;">
        <v-col cols="12" sm="5">
          <v-form>
            <kicklet-textarea
                v-model="text"
                :label="$t('emotes.labels.text')"
            >
              <template v-slot:append>
                <color-picker
                    v-model="textColor"
                />
              </template>
            </kicklet-textarea>
            <kicklet-select
                :label="$t('panels.labels.font')"
                v-model="font"
                :items="assets.font"
            >
              <template v-slot:item="{ props }">
                <v-list-item v-bind="props" :style="{ fontFamily: props.value }">
                </v-list-item>
              </template>
              <template v-slot:append>
                <v-avatar color="transparent"></v-avatar>
              </template>
            </kicklet-select>
            <v-checkbox
                v-model="textShadow"
                :label="$t('panels.labels.text-shadow')"
            >
              <template v-slot:append>
                <color-picker v-model="shadowColor"></color-picker>
              </template>
            </v-checkbox>
          </v-form>
          <kicklet-button
              :text="$t('panels.buttons.generate')"
              class="float-end"
              :variant="utils.buttonVariant"
              color="primary"
              prepend-icon="mdi-file-cog"
              @click="generate(true)"
              :loading="loading"
          />
        </v-col>
        <v-col cols="12" offset-sm="1" sm="3">
          <v-img v-if="image" :src="image" height="250px"/>
          <kicklet-loading v-else />
          <kicklet-button
              :text="$t('panels.buttons.download')"
              class="float-end mt-5"
              :variant="utils.buttonVariant"
              color="primary"
              prepend-icon="mdi-download"
              :href="image"
              v-if="!loading"
          />
        </v-col>
      </v-row>
    </template>
  </custom-card>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import ColorPicker from '@/components/ColorPicker';
import { ImageGenerator } from '@/services/ImageGenerator';
import KickletLoading from '@/components/custom/kicklet/KickletLoading.vue';
import { Analytics } from '@/services/Analytics';
import CustomCard from '@/components/custom/CustomCard.vue';
import KickletButton from '@/components/custom/kicklet/KickletButton.vue';
import KickletSelect from '@/components/custom/kicklet/KickletSelect.vue';
import KickletTextarea from '@/components/custom/kicklet/KickletTextarea.vue';

const assets = ref({
  font: [],
});

const loading = ref(true);

const text = ref('SUB\nGIFT');
const textShadow = ref(false);
const textColor = ref('#97CB2A');
const shadowColor = ref('#000000BD');
const font = ref(null);

const image = ref(null);

function generate (track) {
  const options = {
    lines: text.value.split('\n'),
    font: font.value,
    fontColor: textColor.value,
    textShadow: textShadow.value,
  };

  if (textShadow.value) {
    options.shadowColor = shadowColor.value;
  }

  image.value = ImageGenerator.generateEmoteUrl(options);

  if (track) {
    Analytics.event('emote_generate', options);
  }
}

onMounted(() => {
  ImageGenerator.getAllAssets()
    .then(data => {
      data.panel = data.panel.map(p => ({ ...p, image: ImageGenerator.panelUrl(p.id) }));
      assets.value = data;
      font.value = data.font[0];

      let styles = '';

      data.font.forEach(font => {
        styles += `
          @font-face {
           font-family: '${font}';
           src: url('${ImageGenerator.fontUrl(font)}') format('woff2');
         }
       `;
      });

      const styleEl = document.createElement('style');
      styleEl.textContent = styles;
      document.head.appendChild(styleEl);

      generate();
      loading.value = false;
    })
    .catch(err => console.log(err));
});

</script>

<style scoped>
</style>
